import React from 'react';

const MaterialSelectedList = ({ materials }) => {
  // Function to chunk the materials array into groups of 4
  const chunkArray = (array, chunkSize) => {
    const chunks = [];
    for (let i = 0; i < array.length; i += chunkSize) {
      chunks.push(array.slice(i, i + chunkSize));
    }
    return chunks;
  };
  
  // Split materials into columns with 4 items each
  const columns = chunkArray(materials, 4);
  
  return (
    <div className="flex flex-wrap mt-4 gap-4">
      {columns.map((column, columnIndex) => (
        <div key={columnIndex} className="min-w-[200px] flex-1">
          <div className="bg-gray-50 p-3 rounded-lg shadow-sm">
            {column.map((material) => (
              <div 
                key={material.id+"_"+material.item.Item_name} 
                className="mb-2 p-2 bg-white rounded border border-gray-200 last:mb-0"
              >
                <div className="text-sm font-semibold">{material.type}</div>
                <div className="text-xs text-gray-500">{material.item.Item_name}</div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default MaterialSelectedList;